// Query keys are scoped by the active org id so that an org switch (new
// X-OptiID-Org-Id from Prism) re-fetches everything without a full reload.
export const queryKeys = {
  apiKeys: {
    status: (orgId: string | null) => ['api-keys', 'status', orgId] as const,
  },
  apps: {
    list: (orgId: string | null) => ['apps', 'list', orgId] as const,
    versions: (orgId: string | null, appId: string) =>
      ['apps', 'versions', orgId, appId] as const,
    installations: (orgId: string | null, appId: string) =>
      ['apps', 'installations', orgId, appId] as const,
  },
};
